import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Form, Formik } from 'formik'
import DatePicker from 'react-datepicker'
import { ArrowLeft } from 'react-bootstrap-icons'
import Modal from '../../../../Modal/Modal'
import { TimelineItemDatesSchema } from '../../../../../schemas/TimelineItemDatesSchema'
import { TimelineContext } from 'contexts/TimelineContext'
import { CampaignContext } from 'contexts/CampaignContext'
import { format } from 'date-fns'
import CampaignScenariosProjectAsset from '../../../../../models/CampaignScenariosProjectAsset'
import ProjectAsset from '../../../../../models/ProjectAsset'
export default observer(function TimelineChangeDatesModal({ 
  isOpen, 
  onClose, 
}) {
  const { timelineState, selectedTimelineAsset } = useContext(TimelineContext)
  const { projectAssets, campaignScenarios } = useContext(CampaignContext)

  const isProjectAsset = selectedTimelineAsset instanceof CampaignScenariosProjectAsset
  const isNotScheduledAsset = selectedTimelineAsset instanceof ProjectAsset

  const initialValues = {
    startDate: selectedTimelineAsset?.start_date ? new Date(selectedTimelineAsset.start_date) : new Date(),
    endDate: selectedTimelineAsset?.end_date ? new Date(selectedTimelineAsset.end_date) : new Date()
  }

  const handleDateChange = async (values) => {
    if (!selectedTimelineAsset?.id) {
      console.error('No valid asset ID found')
      timelineState.toggleChangeDatesModal()
      return
    }
    
    const campaignScenario = campaignScenarios[0]
    
    // Check if the asset exists in the campaign scenario
    const assetExists = isProjectAsset
      ? campaignScenario?.campaign_scenarios_project_assets
        ?.some(asset => {
          return +asset.id === +selectedTimelineAsset.id
        })
      : campaignScenario?.actions?.some(action => {
          return +action.id === +selectedTimelineAsset.id
        })
    
    if (!assetExists && !isNotScheduledAsset) {
      console.error('Asset not yet saved to database')
      timelineState.toggleChangeDatesModal()
      return
    }


    const oldDate = selectedTimelineAsset.start_date || format(values.startDate, 'yyyy-MM-dd')
    const newStartDate = format(values.startDate, 'yyyy-MM-dd')
    const newEndDate = values.endDate ? format(values.endDate, 'yyyy-MM-dd') : null
    const isNewItem = !Array.from(timelineState.timelineItems.values())
    .flat()
    .some(item => +item.id === +selectedTimelineAsset.id)

    try {
      if (oldDate === newStartDate && isNewItem) {
        if (isNotScheduledAsset) {
          await timelineState.addProjectAssetToTimeline(projectAssets, campaignScenario, selectedTimelineAsset.id, newStartDate, newEndDate)
        } else {
          await timelineState.addActionToTimeline(campaignScenario, selectedTimelineAsset.id, newStartDate, newEndDate)
        }
      } else {
        await timelineState.updateTimelineItemDate(selectedTimelineAsset, oldDate, newStartDate, newEndDate, campaignScenario)
      }
      timelineState.toggleChangeDatesModal()
    } catch (error) {
      console.error('Error updating dates:', error)
      timelineState.toggleChangeDatesModal()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} hasSideBar>
      <Modal.Body>
        <div className="p-2 dark:bg-rb-dark-mode">
          <div className="flex justify-between items-center pb-4">
            <h2 className='font-bold text-2xl dark:text-white'>Change Dates</h2>
            <Modal.DissmissButton className='flex items-center p-2 rounded-lg hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white'>
              <ArrowLeft className='mr-1 font-bold' /><span className='font-bold'>Back</span>
            </Modal.DissmissButton>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={TimelineItemDatesSchema}
            onSubmit={handleDateChange}
          >
            {({ values, errors, touched, setFieldValue, handleBlur}) => (
              <Form>
                <div className="flex gap-4 mb-6">
                  <div className="flex-1">
                    <label className="block mb-2 font-medium dark:text-white">Start Date</label>
                    <DatePicker
                      name="startDate"
                      selected={values.startDate}
                      onChange={(date) => setFieldValue('startDate', date)}
                      className={`w-full p-2 border dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:text-white rounded-lg ${touched.startDate && errors.startDate ? 'border-red-500' : ''}`}
                      dateFormat="yyyy-MM-dd"
                      showPopperArrow={false}
                      popperClassName="react-datepicker-popper"
                      popperPlacement="bottom-start"
                      calendarClassName="react-datepicker"
                      error={touched.startDate && errors.startDate}
                      onBlur={handleBlur}
                    />
                    {touched.startDate && errors.startDate && (
                      <div className="text-red-500 text-sm mt-1">{errors.startDate}</div>
                    )}
                  </div>
                  <div className="flex-1">
                    <label className="block mb-2 font-medium dark:text-white">End Date</label>
                    <DatePicker
                      name="endDate"
                      selected={values.endDate}
                      onChange={(date) => setFieldValue('endDate', date)}
                      className={`w-full p-2 border dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:text-white rounded-lg ${touched.endDate && errors.endDate ? 'border-red-500' : ''}`}
                      dateFormat="yyyy-MM-dd"
                      minDate={values.startDate}
                      showPopperArrow={false}
                      popperClassName="react-datepicker-popper"
                      popperPlacement="bottom-start"
                      calendarClassName="react-datepicker"
                      error={touched.endDate && errors.endDate}
                      onBlur={handleBlur}
                    />
                    {touched.endDate && errors.endDate && (
                      <div className="text-red-500 text-sm mt-1">{errors.endDate}</div>
                    )}
                  </div>
                </div>

                <div className="flex justify-between mt-7">
                  <Modal.DissmissButton className='rb-btn-cancel font-bold text-lg ml p-2 px-4 rounded-lg'>
                    <span className='font-bold'>Cancel</span>
                  </Modal.DissmissButton>

                  <button
                    type="submit"
                    className="ml-auto bg-rb-green text-white font-bold rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green dark:text-rb-dark-mode"
                  >
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  )
})